import { Button } from '@/components/ui/button';
import useGetUserProfileInfo from '@/hooks/auth/useGetUserProfileInfo';
import { useFollowMutation, useUnfollowMutation, useUpdateFollowStatusMutation } from '@/hooks/following/useFollowing';
import { TFeedMode } from '@/pages/feed';
import { DbCloudWalletUserInfo, ExtendedDbCloudWalletUserInfo } from '@shared/types/db/user';
import Image from 'next/image';
import { toast } from 'sonner';
export default function PeopleItem({
  user,
  mode
}: {
  user: ExtendedDbCloudWalletUserInfo;
  mode: TFeedMode;
}) {
  const followMutation = useFollowMutation();
  const unFollowMutation = useUnfollowMutation();
  const updateStatusMutation = useUpdateFollowStatusMutation();
  const {
    userName
  } = useGetUserProfileInfo();
  const displayText = () => {
    //userIsPending + userIsFollowing added in as extra fields for searchResults
    if (user.status == 'pending' || user.userIsPending) {
      if (mode == 'Requests') {
        return ['Accept', 'Dismiss'];
      }
      return ['Cancel'];
    }
    if (user.status == 'public' || user.status == 'private' || user.userIsFollowing) {
      if (mode == 'Following') {
        return ['Unfollow'];
      }
      if (mode == 'Followers') {
        return ['Remove'];
      }
      return ['Unfollow'];
    }
    if (user.is_private) {
      return ['Add +'];
    }
    return ['Follow +'];
  };
  const handleFollow = async () => {
    try {
      await followMutation.mutateAsync({
        username: userName,
        userToFollow: user.username
      });
      if (user.is_private) {
        toast.success('Follow request sent', {
          duration: 1000
        });
      } else {
        toast.success('Followed', {
          duration: 1000
        });
      }
    } catch (e) {
      console.error('Error following user:', e);
      toast.error('Error following user', {
        duration: 1000
      });
    }
  };
  const handleUnfollow = async () => {
    try {
      await unFollowMutation.mutateAsync({
        username: userName,
        userToUnfollow: user.username
      });
      if (user.status != 'pending') {
        toast.success('Unfollowed', {
          duration: 1000
        });
      } else {
        toast.success('Request cancelled', {
          duration: 1000
        });
      }
    } catch (e) {
      console.error('Error unfollowing user:', e);
      toast.error('Error unfollowing user', {
        duration: 1000
      });
    }
  };
  const handleDismiss = async () => {
    try {
      console.log('useelkfhewr', user);
      await unFollowMutation.mutateAsync({
        username: user.username,
        userToUnfollow: userName
      });
      if (user.status != 'pending') {
        toast.success('Dismissed', {
          duration: 1000
        });
      } else {
        toast.success('Request removed', {
          duration: 1000
        });
      }
    } catch (e) {
      console.error('Error unfollowing user:', e);
      toast.error('Error dismissing user', {
        duration: 1000
      });
    }
  };
  const handleAccept = async () => {
    try {
      await updateStatusMutation.mutateAsync({
        followerUsername: user.username,
        newStatus: 'private'
      });
      toast.success('Accepted', {
        duration: 1000
      });
    } catch (e) {
      console.error('Error accepting user:', e);
      toast.error('Error accepting user', {
        duration: 1000
      });
    }
  };
  return <div className='h-[60px] flex flex-col p-2 my-2 rounded-lg' data-sentry-component="PeopleItem" data-sentry-source-file="PeopleItem.tsx">
      <div className='flex items-center'>
        <Image src={'/static/genie/' + user.pfp} className='w-[40px] h-[40px] ml-2 rounded-full' alt='avatar' width={40} height={40} data-sentry-element="Image" data-sentry-source-file="PeopleItem.tsx" />
        <div className='flex justify-between items-center w-full'>
          <div className='flex flex-col items-start justify-start ml-4 '>
            <p className='text-md text-genius-cream '>{user.first_name}</p>
            <p className='text-sm text-genius-cream/50 ml'>{user.username}</p>
          </div>
          <div className='flex items-center space-x-2'>
            {displayText().map(text => {
            return <Button onClick={() => {
              if (text == 'Follow +') {
                handleFollow();
              } else if (text == 'Add +') {
                handleFollow();
              } else if (text == 'Unfollow') {
                handleUnfollow();
              } else if (text == 'Cancel') {
                handleUnfollow();
              } else if (text == 'Accept') {
                handleAccept();
              } else if (text == 'Dismiss' || text == 'Remove') {
                handleDismiss();
              }
            }} className='w-[71px] h-[36px] text-[12px] bg-genius-blue text-genius-cream hover:text-genius-cream hover:bg-genius-blue rounded-[8px] hover:border-genius-indigo hover:border-[1px]'>
                  {/* added fields */}
                  {text}
                </Button>;
          })}
          </div>
        </div>
      </div>
    </div>;
}